import React, { useState } from "react";
import { FaCopy } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";

function DeployUI({ userId, botId }) {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = async () => {
    const text = document.getElementById("textcopy-1")?.textContent;
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 3000);
    } catch (err) {
      console.error("Failed to copy: ", err);
      setCopySuccess(false);
    }
  };

  return (
    <div className="h-max flex-1 2xl:text-lg flex flex-col text-white bg-gray-800 p-5 rounded-lg gap-5 shadow-lg">
      <h3 className="text-xl 2xl:text-2xl font-semibold tracking-wide">
        Embed Chatbot with Iframe
      </h3>

      <div className="relative bg-gray-900 p-5 w-full rounded-lg flex flex-col gap-4">
        <div className="absolute top-4 right-4">
          <button
            onClick={handleCopy}
            className="flex items-center gap-2 px-3 py-1.5 bg-gray-700 hover:bg-gray-600 rounded-md transition">
            <FaCopy className="w-5 h-5" />
            {copySuccess ? <span className="text-sm">Copied</span> : null}
          </button>
        </div>

        <Tooltip
          style={{ background: "rgba(248,250,252,0.3)" }}
          place="top"
          anchorSelect="#tooltip-copy-I"
          variant="warning"
          float={true}>
          <span className="text-white font-bold">Copy</span>
        </Tooltip>

        <div
          id="textcopy-1"
          className="max-w-full break-all text-base 2xl:text-lg bg-gray-950 p-4 rounded-lg">
          {`<iframe
  src="${process.env.REACT_APP_CLIENT_APP}/chatapp/${userId}/${botId}/true/false"
  style="width:100%; height: 100%; border: none; position:fixed; bottom:5px; z-index:999; max-width:100vw; max-height:90vh;"
></iframe>`}
        </div>
      </div>

      <div>
        <span className="text-lg 2xl:text-xl font-medium">Description</span>
        <p className="text-gray-300 text-sm 2xl:text-lg mt-1">
          To add the chatbot anywhere on your website, simply place this iframe
          within your HTML code.
        </p>
      </div>
    </div>
  );
}

export default DeployUI;
